<template>
	<v-container fluid tag="section">
		<ti-card :icon="$icons.team_members">
			<template #title>Team Members</template>
			<template #title-actions-shown>
				<v-btn color="success" elevation="2" fab small :to="{name: 'TeamMembersNew'}">
					<v-icon>{{ $icons.new }}</v-icon>
				</v-btn>
			</template>
			<v-data-table :headers="headers" :items="team_members" item-key="id" :search="search" @click:row="editItem" :item-class="() => 'hover-pointer'">
				<template v-slot:top>
					<v-row justify="end">
						<v-col cols="12" lg="6">
							<v-text-field
								v-model="search"
								label="Search"
								prepend-icon="mdi-magnify"
								class="mx-4"
							></v-text-field>
						</v-col>
					</v-row>
				</template>
			</v-data-table>
		</ti-card>
	</v-container>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
	name: "TeamMembersIndex",
	computed:{
		team_members: sync('team_members/team_members')
	},
	data: () => ({
		search: '',
		headers:[
			{
				text: 'Name',
				align: 'start',
				sortable: true,
				value: 'name',
			},
			{
				text: 'Title',
				align: 'start',
				sortable: true,
				value: 'title',
			},
		]
	}),
	beforeMount(){
		this.init()
	},
	methods:{
		init(){
			this.getTeamMembers()
		},
		editItem(data){
			this.$router.push({name:'TeamMembersEdit', params: {id: data.id}})
		},
		getTeamMembers(){
			this.$store.set('team_members/getTeam_members!', null)
		},
		filterOnlyCapsText (value, search, item) {
			return value != null &&
				search != null &&
				typeof value === 'string' &&
				value.toString().toLocaleUpperCase().indexOf(search) !== -1
		},
	}
}
</script>